import React from "react";
import Logo from "../assets/logo-herbal-tea-therapy white.png";

const NavBar = () => {
  return (
    <div className=" bg-[#204058] p-2.5 pb-0 md:px-6">
      <div className=" max-w-6xl mx-auto border-b-4 border-[#3c6f95]">
        <img src={Logo} alt="logo" className="w-36 object-contain pb-2.5" draggable="false" />
      </div>
    </div>
  );
};

export default NavBar;  
